import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Col, Info, Paper, Row } from 'redpoints-front-components/index';
import { PriorityTag, withChannels } from 'redpoints-front-common/components';

import {
  getTestPurchaseLinkInfoLinkChannel,
  getTestPurchaseLinkInfoLinkId,
  getTestPurchaseLinkInfoLinkIsReopened,
  getTestPurchaseLinkInfoLinkStatus,
  getTestPurchaseLinkInfoLinkType,
  getTestPurchaseLinkInfoLinkUrl,
  getTestPurchaseLinkInfoPriority,
} from '../../../reducers/tasks/testPurchase';
import { translate } from './../../../helpers/languageHelper';

import './testPurchaseLinkInfo.less';

const TestPurchaseLinkInfo = ({
  channel,
  linkStatus,
  linkId,
  linkType,
  linkUrl,
  priority,
  reopenFromLinkId,
}) => (
  <Paper className="test-purchase-link-info">
    <Row className="test-purchase-link-info__linkUrl" gutter={16}>
      <Col xs={24} lg={20}>
        <Info
          label={translate('tasks.testPurchase.linkInfo.fields.linkLabel')}
          value={
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
              {linkUrl}
            </a>
          }
        />
      </Col>
      <Col xs={24} lg={4}>
        <PriorityTag priority={priority} />
      </Col>
    </Row>
    <Row gutter={16}>
      <Col xs={24} lg={5}>
        <Info
          label={translate(
            'tasks.testPurchase.linkInfo.fields.channelTypeLabel'
          )}
          value={translate(`global.${channel?.literalKey}`)}
        />
      </Col>
      <Col xs={24} lg={5}>
        <Info
          label={translate('tasks.testPurchase.linkInfo.fields.linkTypeLabel')}
          value={translate(
            `tasks.testPurchase.linkInfo.fields.${linkType?.literalKey}`
          )}
        />
      </Col>
      <Col xs={24} lg={5}>
        <Info
          label={translate('tasks.testPurchase.linkInfo.fields.linkIdLabel')}
          value={linkId}
        />
      </Col>
      <Col xs={24} lg={5}>
        <Info
          label={translate(
            'tasks.testPurchase.linkInfo.fields.linkStatusLabel'
          )}
          value={translate(
            `tasks.testPurchase.linkInfo.fields.${linkStatus?.literalKey}`
          )}
        />
      </Col>
      <Col xs={24} lg={4}>
        <Info
          label={translate('tasks.testPurchase.linkInfo.fields.reopenedLabel')}
          value={
            reopenFromLinkId
              ? translate('tasks.testPurchase.linkInfo.fields.reopened.yes')
              : translate('tasks.testPurchase.linkInfo.fields.reopened.not')
          }
        />
      </Col>
    </Row>
  </Paper>
);

const mapStateToProps = (state, { getChannelById }) => ({
  channel: getTestPurchaseLinkInfoLinkChannel(state, getChannelById),
  linkId: getTestPurchaseLinkInfoLinkId(state),
  linkStatus: getTestPurchaseLinkInfoLinkStatus(state),
  linkType: getTestPurchaseLinkInfoLinkType(state),
  linkUrl: getTestPurchaseLinkInfoLinkUrl(state),
  priority: getTestPurchaseLinkInfoPriority(state),
  reopenFromLinkId: getTestPurchaseLinkInfoLinkIsReopened(state),
});

export default compose(
  withChannels,
  connect(mapStateToProps),
  memo
)(TestPurchaseLinkInfo);
